import React from 'react'
import {
  BodyTextBold,
  TopBarLeftContentDesktop,
  TopBarLeftContentMobile,
  TopBarRightContent,
  TopBar as ToqioTopBar,
} from '@toqio/toqio-web-components'

import { SecondaryIconButtonXS } from 'src/components/icon-button'
import useAuthStore from 'src/models/auth/auth.store'

const TopBar = React.forwardRef((props : any) => {
  const onClickOpenSideBar = () => {
    props.forwardedRef?.current?.openSidebar()
  }
  
  const { logout } = useAuthStore();
  
  return(
    <ToqioTopBar className='toqio-topbar'>
      <TopBarLeftContentMobile>
        <SecondaryIconButtonXS
          name='icn_menu'
          onClick={onClickOpenSideBar}
        />
      </TopBarLeftContentMobile>
      <TopBarLeftContentDesktop>
        <BodyTextBold>
          {process.env.CUSTOMER_LONG_NAME}
        </BodyTextBold>
      </TopBarLeftContentDesktop>
      <TopBarRightContent>
        <SecondaryIconButtonXS 
          name='icn_logout'
          onClick={logout}
        />
      </TopBarRightContent>
    </ToqioTopBar>
  )
})

export default TopBar;